import React from "react";
import { RCCGrid, RCCIcon, RCCTooltip } from "react-common-components";
import { Link } from "react-router-dom";
import { useTranslation } from "src/context/Translations/context";
import AppIcons from "../AppIcons";
import Title from "../Title";
import IComponentPageTitle from "./interface";
import Container from "./styles";

const PageTitle: React.FC<IComponentPageTitle> = (
	{
		title,
		icon,
		children,
		trashLink
	}) => {
	const { translate } = useTranslation();
	return(
		<RCCGrid
			container 
			item
			alignItems="center"
			justifyContent="space-between"
		>
			<Container>
				{icon && (
					<>
						{typeof icon !== "function" ? (
							<RCCIcon 
								{...icon}
								size={18}
								color="var(--purple-lighter)"
								style={{marginRight: "3px"}}
							/>
						): icon()}
					</>
				)}
				<Title color="purple" size="xl">
					{title}
				</Title>
				{trashLink && (
					<div className="trashScreenLink">
						<RCCTooltip
							text={translate("Lixeira")}
							color="grey"
						>
							<Link to={`/trash/${trashLink}`}>
								<AppIcons name="trash" />
							</Link>
						</RCCTooltip>
					</div>
				)}
			</Container>
			{children && (
				<Container>
					{children}
				</Container>
			)}
		</RCCGrid>
	);};

export default PageTitle;
